import { Position } from "@deck.gl/core"
import { InfraredImageWithContext } from "@nova/constants"
import { InfraredImage } from "@nova/protobuf"
import { getVideoFrameBboxAsync } from "features/map/layers/video/VideoProjectionLayer"
import useSWR from "swr"

const useInfraredImageBoundingBox = (
    infraredImage?: InfraredImageWithContext,
    callback?: (pos: [Position, Position, Position, Position] | undefined) => void
) =>
    useSWR(
        `bbox-${infraredImage?.id}`,
        () =>
            infraredImage &&
            getVideoFrameBboxAsync([
                infraredImage.longitude!,
                infraredImage.latitude!,
                infraredImage.height!,
                infraredImage.pitch!,
                infraredImage.yaw!,
                infraredImage.roll!,
                infraredImage.fov!,
                infraredImage.altitude!,
            ]).then((res) => {
                if (!res) return undefined
                res.unshift(res.pop()!)
                return res as [Position, Position, Position, Position]
            }),
        { onSuccess: callback }
    )

const getInfraredBoundingBox = (
    infraredImage: InfraredImage | undefined,
    callback?: (result: [Position, Position, Position, Position]) => void
) =>
    infraredImage &&
    getVideoFrameBboxAsync([
        infraredImage.longitude!,
        infraredImage.latitude!,
        infraredImage.height!,
        infraredImage.pitch!,
        infraredImage.yaw!,
        infraredImage.roll!,
        infraredImage.fov!,
        infraredImage.altitude!,
    ])
        .then((res) => {
            if (!res) return undefined
            res.unshift(res.pop()!)
            return res as [Position, Position, Position, Position]
        })
        .then((result) => {
            if (result) callback?.(result)
            return result
        })

export { useInfraredImageBoundingBox, getInfraredBoundingBox }
